﻿import { useState } from 'react';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Tooltip } from '@mui/material';

export default function useReverseSort(parameter, reverseBool = false) {
  //set reverseBool to true if you want data reversed on initial render
  const [reversed, setReversed] = useState(reverseBool);

  const sortWithReverse = (arr) => {
    if (!reversed) {
      return arr.sort((a, b) => a[parameter].localeCompare(b[parameter]));
    }
    return arr.sort((b, a) => a[parameter].localeCompare(b[parameter]));
  };

  const ReverseIcon = () => {
    return (
      <Tooltip title="Reverse Order">
        {reversed ? (
          <ArrowDropUpIcon style={{ paddingBottom: '.05rem' }} />
        ) : (
          <ArrowDropDownIcon style={{ paddingBottom: '.05rem' }} />
        )}
      </Tooltip>
    );
  };

  return {
    reversed,
    setReversed,
    sortWithReverse,
    ReverseIcon,
  };
}
